import { listFacetValues } from '@/function/list/list.facet.values';
import type { TypeListFindConfig, TypeListFindState } from '@/types/list/types.list.find';
import { dateWindowMatch } from '@/utils/date/date.window.match';

const normalize = (value: string): string => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const listFindMatch = <T>(
    items: readonly T[],
    config: TypeListFindConfig<T>,
    state: TypeListFindState,
    now: Date = new Date(),
    skipFacet: string | null = null,
): T[] => {
    const words = normalize(state.search.trim()).split(/\s+/).filter(Boolean);
    const facets = (config.facets ?? []).filter((facet) => facet.of && facet.id !== skipFacet && (state.active[facet.id]?.length ?? 0) > 0);
    const dates = (config.dates ?? []).filter((date) => date.of && state.dates[date.id]);

    return items.filter((item) => {
        if (words.length && config.text) {
            const haystack = normalize(config.text(item));
            if (!words.every((word) => haystack.includes(word))) return false;
        }
        for (const facet of facets) {
            const selected = state.active[facet.id];
            const hit = listFacetValues(facet.of?.(item)).some((value) => selected.includes(value));
            if (hit === Boolean(state.excluded[facet.id])) return false;
        }
        for (const date of dates) {
            if (!dateWindowMatch(state.dates[date.id], date.of?.(item), now)) return false;
        }
        return true;
    });
};

export default listFindMatch;
